import { getRoundedInput } from './getRoundedInput';

export const getIncrementedValue = (value: number, step: number, max: number, allowDecimal: boolean) => {
  const incrementedValue = value + step;
  const newValue = typeof max !== 'undefined' ? Math.min(incrementedValue, max) : incrementedValue;

  return getRoundedInput(newValue, allowDecimal);
};
